import React from 'react'
import { SvgIconProps } from './Home'

const SvgSurveysIcon = ({ fill, width, height }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ?? '17'}
    height={height ?? '20'}
    fill="none"
    viewBox={`0 0 ${width ?? '17'} ${height ?? '20'}`}
  >
    <path
      fill={fill ?? '#353535'}
      d="M13.688 1.29h-2.87C10.377.538 9.494 0 8.5 0c-.331 0-.552 0-.883.108-.662.215-1.104.645-1.435 1.182h-2.87C1.545 1.29 0 2.688 0 4.516v12.258C0 18.494 1.435 20 3.312 20h10.376C15.454 20 17 18.602 17 16.774V4.516c-.11-1.828-1.546-3.226-3.312-3.226zM6.292 5.914h4.305c1.104 0 1.987-.86 1.987-1.936v-.537h1.104c.552 0 1.104.43 1.104 1.075v12.258c0 .538-.441 1.075-1.104 1.075H3.312c-.552 0-1.104-.43-1.104-1.075V4.516c0-.538.441-1.075 1.104-1.075h1.104v.537c-.11 1.076.772 1.936 1.876 1.936zm3.643-2.473h.442v.322H6.513v-.322h1.214l.11-.645V2.58c.111-.215.332-.43.663-.43h.11c.221 0 .332.215.442.43v.215l.11.645h.773z"
    ></path>
    <path
      fill={fill ?? '#353535'}
      d="M3.532 8.602v1.506c0 .537.442.967.994.967h1.545c.552 0 .994-.43.994-.967V8.602a.977.977 0 00-.994-.967H4.526a.977.977 0 00-.994.967zM9.604 10.43h3.422c.552 0 .993-.43.993-1.075s-.441-1.075-.993-1.075H9.604c-.552 0-.994.43-.994 1.075s.442 1.075.994 1.075zM5.961 11.935H4.526a.977.977 0 00-.994.968v1.506c0 .537.442.967.994.967h1.545c.552 0 .994-.43.994-.967v-1.506c-.11-.537-.552-.968-1.104-.968zM9.604 14.731h3.422c.552 0 .993-.43.993-1.075s-.441-1.075-.993-1.075H9.604c-.552 0-.994.43-.994 1.075s.442 1.075.994 1.075z"
    ></path>
  </svg>
)

export default SvgSurveysIcon
